import { Action } from 'redux';

import { DeletePublishedConnectionDraft } from '~src/bootstrap/redux/actions/AppActionTypes';

export interface DeletePublishedConnectionDraftReduxAction extends Action {
  readonly draftLuid: string;
}

export function deletePublishedConnectionDraft(draftLuid: string): DeletePublishedConnectionDraftReduxAction {
  return {
    type: DeletePublishedConnectionDraft,
    draftLuid
  };
}
